import { Navigate, RouteObject } from "react-router";
import { ProcessConfiguredGuard } from "../_components/process-configured-guard";
import { OffersRoute } from "./offers/offers-route";
import { wrhOffersRoutes } from "./offers/offers-routes";
import OverviewRoute from "./overview/overview-route";
import ContactRoute from "./contact/contact-route";

export const wrhRoutes: RouteObject[] = [
  {
    element: <Navigate to="overview" replace />,
    index: true,
  },
  {
    path: "overview",
    element: <OverviewRoute />,
  },
  {
    path: "contact",
    element: <ContactRoute />,
  },
  // The following routes require a fully configured process.
  // The elements are wrapped with an appropriate guard, to
  // notify the user.
  ...[
    {
      path: "offers",
      element: <OffersRoute />,
      children: wrhOffersRoutes,
    },
  ].map((route) => ({
    ...route,
    element: (
      <ProcessConfiguredGuard serviceObjectsRequired={false}>
        {route.element}
      </ProcessConfiguredGuard>
    ),
  })),
];
